export default __webpack_public_path__ + "static/media/screenshot-1.8af4312e.png";